"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EFormStatus;
(function (EFormStatus) {
  EFormStatus["Default"] = "default";
  EFormStatus["Loading"] = "loading";
  EFormStatus["Invalid"] = "invalid";
  EFormStatus["Success"] = "success";
  EFormStatus["Error"] = "error";
  EFormStatus["Resubmitting"] = "resubmitting";
  EFormStatus["InvalidInn"] = "invalidInn";
})(EFormStatus || (EFormStatus = {}));
var _default = EFormStatus;
exports.default = _default;